import { RootState } from 'types/store';

export const selectCurrentUser = (state: RootState) => state.user;

export const selectUserFeatures = (state: RootState) => state.user.features;

export const selectUserPlatform = (state: RootState) => state.user.initial_platform;

export const selectFitnessLevel = (state: RootState) => state.user.fitness_level;
